import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function AgentTrustPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="trust" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
